import styled from '@emotion/styled'
import {
  MESSAGE_BOX_VARIANT_DANGER,
  MESSAGE_BOX_VARIANT_WARNING,
  MessageBox
} from 'mailup-web-components'
import { useIntl } from 'react-intl'
import { useRecoilValue } from 'recoil'

import { notifyParent } from 'mailup-react-helpers'

import {
  PECPLUS_STATUS_ERROR_DESCR,
  PECPLUS_STATUS_IN_PROGRESS_DESCR
} from 'Constants'

import { modalSchedulingState } from 'Pages/EmailSendingQueueManage/recoil/state/modals'
import { pecPlusConfigState } from 'Pages/EmailSendingQueueManage/recoil/state/page'

const VerticalSpace = styled.div`
  margin-bottom: 20px;
`

export const WarningMessage = () => {
  const intl = useIntl()
  const { error, severity } = useRecoilValue(modalSchedulingState)
  const { pecPlusStatus } = useRecoilValue(pecPlusConfigState)

  let variant = MESSAGE_BOX_VARIANT_WARNING
  let msg
  const handleGoToSettingsClick = () => {
    notifyParent('redirectMainFrame', [
      '/console/form_upd_nl.aspx?visualmode=1&tab=mittenti'
    ])
  }

  if (pecPlusStatus === PECPLUS_STATUS_IN_PROGRESS_DESCR) {
    msg = intl.formatMessage(
      { id: 'Load.PecPlus.WarinigConfingInProgressNew' },
      {
        link: chunks => <a onClick={handleGoToSettingsClick}>{chunks}</a>
      }
    )
  }

  if (pecPlusStatus === PECPLUS_STATUS_ERROR_DESCR) {
    variant = MESSAGE_BOX_VARIANT_DANGER
    msg = intl.formatMessage(
      { id: 'Load.Common.ConfigPecErrorNew' },
      {
        link: chunks => <a onClick={handleGoToSettingsClick}>{chunks}</a>
      }
    )
  }

  if (error) {
    msg = intl.formatMessage({ id: error })
    if (severity === 'danger') {
      variant = MESSAGE_BOX_VARIANT_DANGER
    }
  }

  return msg ? (
    <>
      <MessageBox variant={variant}>{msg}</MessageBox>
      <VerticalSpace />
    </>
  ) : null
}
